import React from 'react'

export default function IconInbox({ color = "", style = {} }) {
    let fillColor = "#7246B1";
    if (color) fillColor = color;
    let className = "icons-icon";

    return <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={style}>
        <path d="M18.6667 10H13.6667L12 12.5H8.66667L7 10H2" stroke="#595C61" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.875 4.25837L2 10V15C2 15.4421 2.17559 15.866 2.48816 16.1786C2.80072 16.4911 3.22464 16.6667 3.66667 16.6667H17C17.442 16.6667 17.8659 16.4911 18.1785 16.1786C18.4911 15.866 18.6667 15.4421 18.6667 15V10L15.7917 4.25837C15.6537 3.9807 15.441 3.74702 15.1775 3.58361C14.9139 3.4202 14.6101 3.33354 14.3 3.33337H6.36667C6.0566 3.33354 5.75272 3.4202 5.4892 3.58361C5.22569 3.74702 5.01298 3.9807 4.875 4.25837Z" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
}